import React from "react";
import "./home.scss";
import { useState } from "react";
import Loading from "../../components/loading/Loading";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useEffect } from "react";
import axios from "axios";


const Notifyme = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState([]);

  const columns = [
    { field: "email", headerName: "Email", width: 250 },
    { field: "sku", headerName: "LR-Code", width: 175 },
    //{ field: "id", headerName: "ID", width: 175 },
  ];


   useEffect(() => {
      const getAllProduct = async () => {
        try {
          setLoading(true);
          const response = await axios.get("/get-notify-me");
          // Map API response to DataGrid-compatible format
          const mappedProducts = response.data.map((item) => ({
            sku: item.lrCode || [], // Your LR Code
            email: item.email || "",
            id: item._id || "",
          }));
  
          setNotify(mappedProducts);
        } catch (error) {
          console.error("Error fetching products:", error);
        } finally {
          setLoading(false);
        }
      };
  
      getAllProduct();
    }, []);



  return (
    <div className="main_wrp">
      {loading ? (
        <Loading />
      ) : (
        <div className="main_page_wrp">
          <div className="head_wrp">
            <h5>
              Notify<em> Users</em>
            </h5>
          </div>
          <div className="main_body_wrp">
            <DataGrid
              key={notify.id}
              rows={notify}
              columns={columns}
              pageSize={5}
              disableRowSelectionOnClick
              getRowId={(row) => row.id}
              slots={{ toolbar: GridToolbar }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Notifyme;
